export const BUCKET_NAME = process.env.REACT_APP_BUCKET_NAME;

export const CF_DOMAIN_NAME = process.env.REACT_APP_CF_DOMAIN;

export const S3_HEADER = (user) =>
  `https://${BUCKET_NAME}.s3.amazonaws.com/assets/${user.company.id}/`;

export const CF_DOMAIN = (user) =>
  `https://${CF_DOMAIN_NAME}/assets/${user.company.id}/`;
